module.exports = __webpack_public_path__ + "media/images/sm_icon04-c4216deb99b304a68040bcd44e2a7350.png";